import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[insert-directive]',
    standalone: false
})
export class InsertionDirective {
    constructor(public viewContainerRef: ViewContainerRef) { }
}
